import { motion } from 'framer-motion';
import { CHARACTER_VALUES } from '@/data/content';
import { fadeUp, stagger, viewportOnce } from '@/lib/motion';

export default function Character() {
  return (
    <section id="character" className="relative py-24 sm:py-32 bg-night overflow-hidden" data-testid="character-section">
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_bottom,rgba(197,160,89,0.08),transparent_55%)]" />
      <div className="relative max-w-5xl mx-auto px-4 sm:px-6 text-center">
        <motion.div variants={fadeUp} initial="hidden" whileInView="show" viewport={viewportOnce} className="flex items-center justify-center gap-4 mb-6">
          <span className="font-display text-3xl sm:text-4xl text-stroke-gold leading-none">09</span>
          <span className="h-px w-12 bg-brand-gold/50" />
          <span className="text-xs sm:text-sm uppercase tracking-[0.3em] text-brand-gold font-semibold">More Than a Game</span>
        </motion.div>

        <motion.h2
          variants={fadeUp} custom={1} initial="hidden" whileInView="show" viewport={viewportOnce}
          className="font-display uppercase tracking-tight leading-[0.95] text-4xl sm:text-6xl lg:text-7xl text-white"
        >
          MORE THAN A GAME.<br />
          <span className="text-transparent bg-clip-text bg-gradient-to-r from-brand-goldlight via-brand-gold to-brand-goldlight">IT'S ABOUT CHARACTER.</span>
        </motion.h2>

        <motion.p
          variants={fadeUp} custom={2} initial="hidden" whileInView="show" viewport={viewportOnce}
          className="mt-8 text-base sm:text-lg text-gray-300 leading-relaxed max-w-3xl mx-auto"
        >
          We believe soccer is a powerful way to teach discipline, respect, teamwork, responsibility, confidence and leadership. ASA is a family-oriented, values-driven academy built on a proud Arab heritage — and open-hearted to players and families from every background across our Michigan community.
        </motion.p>

        <motion.div
          variants={stagger} initial="hidden" whileInView="show" viewport={viewportOnce}
          className="mt-12 grid grid-cols-2 sm:grid-cols-3 gap-4"
          data-testid="character-values"
        >
          {CHARACTER_VALUES.map((v, i) => (
            <motion.div
              key={v} variants={fadeUp} custom={i}
              className="gold-hairline rounded-sm py-6 sm:py-8 bg-night/60 hover:bg-brand-gold/10 transition-colors duration-300"
            >
              <span className="font-display text-2xl sm:text-3xl tracking-[0.15em] text-white uppercase">{v}</span>
            </motion.div>
          ))}
        </motion.div>

        <motion.p
          variants={fadeUp} initial="hidden" whileInView="show" viewport={viewportOnce}
          className="mt-10 text-sm text-gray-500 tracking-wide"
        >
          All families. All backgrounds. One standard of excellence.
        </motion.p>
      </div>
    </section>
  );
}
